/* eslint-disable prettier/prettier */
/* eslint-disable max-len */

/*
 * Copyright (c) 2023, WSO2 LLC. (http://www.wso2.com). All Rights Reserved.
 *
 * This software is the property of WSO2 LLC. and its suppliers, if any.
 * Dissemination of any information or reproduction of any material contained
 * herein is strictly forbidden, unless permitted by WSO2 in accordance with
 * the WSO2 Commercial License available at http://wso2.com/licenses.
 * For specific language governing the permissions and limitations under
 * this license, please see the license as well as any agreement you’ve
 * entered into with WSO2 governing the purchase of this software and any
 * associated services.
 */

import { createSvgIcon } from '@material-ui/core';
import * as React from 'react';

export default createSvgIcon(
  <React.Fragment>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M6.25 6.1766c0-.6607.7208-1.0688 1.2873-.7288L12.243 8.271c.5502.3302.5502 1.1276 0 1.4578l-4.7057 2.8233c-.5665.34-1.2873-.0681-1.2873-.7288V6.1766Zm1.5 4.4988L10.5423 9 7.75 7.3246v3.3508Z"
      clipRule="evenodd"
    />
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M9.75 17.9692C14.3696 17.5881 18 13.718 18 9c0-4.9706-4.0294-9-9-9S0 4.0294 0 9c0 4.718 3.6303 8.5881 8.25 8.9692V19.9a.85.85 0 0 0 .85.85h6.9702C16.4213 22.6006 18.0472 24 20 24c2.2091 0 4-1.7909 4-4 0-2.2091-1.7909-4-4-4-1.9528 0-3.5787 1.3994-3.9298 3.25H9.75v-1.2808ZM16.5 9c0 4.1421-3.3579 7.5-7.5 7.5S1.5 13.1421 1.5 9 4.8579 1.5 9 1.5s7.5 3.3579 7.5 7.5Zm6 11c0 1.3807-1.1193 2.5-2.5 2.5s-2.5-1.1193-2.5-2.5 1.1193-2.5 2.5-2.5 2.5 1.1193 2.5 2.5Z"
      clipRule="evenodd"
    />
  </React.Fragment>,
  'MenuCICD'
);
